<template>
    <div>
        <toggle-action-data v-model="data.use_event_custom_attribute"
            :open="!data.use_event_custom_attribute"
            class="mb-2">
            <template v-slot:label>
                Use custom attribute value from trigger event
            </template>

            <vx-label>Entry Channel</vx-label>
            <vx-input size="lg"
                type="text"
                placeholder="e.g., web, mobile, social"
                v-model="data.entry_channel"
                :maxlength="40"
                :error="displayFirstError(validate.entry_channel)">
            </vx-input>
        </toggle-action-data>
    </div>
</template>

<script setup>
import { VxInput, VxLabel } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { helpers, requiredIf, maxLength } from '@vuelidate/validators';
import { displayFirstError } from '~/utils/validation';
import ToggleActionData from './ToggleActionData.vue';

const data = defineModel();

if (data.value.use_event_custom_attribute === undefined) {
    data.value.use_event_custom_attribute = false;
}

const validate = useVuelidate({
    entry_channel: {
        requiredIf: helpers.withMessage('Entry channel is required when not using event custom attribute',
            requiredIf(() => !data.value.use_event_custom_attribute)),
        maxLength: helpers.withMessage('Entry channel must be 40 characters or less', maxLength(40))
    }
}, data);
</script>
